import {PortalEnvironmentType, constants} from '@portal-workspace/grow-shared-library';

export const environment: PortalEnvironmentType = {
  production: false,
  gitTag: "v6.0.7-5-g8d007279e9",
  gitHash: "8d007279e9a648b3e0c3c9045287a26ab040743d",
  api2Host: "https://apitest.dynamoney.com",
  agmApiKey: 'AIzaSyAcitFyUjFmkdY4racefrQNgl2YkCInu7M',
  submitApplicationTermsAndConditionsUrl: 'https://apitest.dynamoney.com/api2/site-assets/tandc/T&Cs.pdf',
  helpCenterUrl: 'https://www.dynamoney.com',
  facebookUrl: 'https://www.facebook.com/growfinancelimited',
  linkedinUrl: 'https://www.linkedin.com/company/dynamoney',
  fxApiKey: '87KJ7Y88739DHEXU',
  invoiceFinanceUrl: 'https://uat-invoicefinance.dynamoney.com/registration/welcome',
  contactUsUrl: 'https://www.dynamoney.com/contact-us',
  brokerProductGuideUrl: 'https://www.dynamoney.com/product-guide/',
  assetProductGuideUrl: 'https://www.dynamoney.com/product-guide/',
  bankStatements: 'https://staging-bankstatements.dynamoney.com',
  idVerify: 'https://portaltest.dynamoney.com/id',
  GrowFinanceGroupSalesforceId: '0019j00000iRWJaAAO', // NOTE: this is (application AppInfo BrokerSalesforceId) / OriginatorBusiness or Arggregator SalesforceId
  OverdraftCustomerRecordTypeId: '0128t0000004I2jAAE',
  GrowFinanceGroupName: "DYNAMONEY",
  appInsightsKey: '9a544814-1d2a-48b4-b89f-673b6a5dab82',
  autoRefreshToken: true,
  applicationSubmission: {
    disabledMessage: 'We have temporarily ceased accepting new applications for this product. Please follow us on the relaunch of this product.',
    internalAccessMessage: `Currently this application is only open for internal users. Please follow us for more information.`,
    AssetFinance: 'enabled',
    BusinessLoans: 'enabled',
    InsurancePremium: 'enabled',
    BusinessOverdraft: 'enabled',

  },
  localStorage: {
    encryptionKey: 'a3YKnFwJ/X+hIoAnnPNoIrViZhWzT95LTK5b2dSMIe6MJEGfiQoCsQulAh9FuoBf',
  },
  verimoto: {
    lender: {
      name: "Dynamoney-Formally Grow Finance",
      guid: "81996595-814D-4AB8-8EB7-E8EECB37CC61"
    },
    verimotoInspectionTypes: constants.verimotoInspectionTypesSandbox
  },
  customerPortalUrl: 'https://customertest.dynamoney.com',
  portalUrlPrefix: 'https://portaltest.dynamoney.com',
  serviceWorker: {
    enable: true,
    debugLogging: true,
    pageRefresh: true,
    skipRefreshConfim: true
  },
  awsCognitoIdentityPoolId: "ap-southeast-2:4db851f2-94f8-496f-8aa8-ebccc369ff64",
  awsCognitoRegion: "us-east-1",
  frankieOnePortalUrl: 'https://portal.kycaml.uat.frankiefinancial.io',
  livenessThreshold: 70,
  faceCompareRetryTimes: 8,
};

